/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCurrentUserPylonUnreadBaselineRequest
 */
export interface UpdateCurrentUserPylonUnreadBaselineRequest {
    /**
     * Pylon unread-message count to treat as already acknowledged
     */
    pylon_unread_baseline: number;
}

/**
 * Check if a given object implements the UpdateCurrentUserPylonUnreadBaselineRequest interface.
 */
export function instanceOfUpdateCurrentUserPylonUnreadBaselineRequest(value: object): value is UpdateCurrentUserPylonUnreadBaselineRequest {
    if (!('pylon_unread_baseline' in value) || value['pylon_unread_baseline'] === undefined) return false;
    return true;
}

export function UpdateCurrentUserPylonUnreadBaselineRequestFromJSON(json: any): UpdateCurrentUserPylonUnreadBaselineRequest {
    return UpdateCurrentUserPylonUnreadBaselineRequestFromJSONTyped(json, false);
}

export function UpdateCurrentUserPylonUnreadBaselineRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCurrentUserPylonUnreadBaselineRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'pylon_unread_baseline': json['pylon_unread_baseline'],
    };
}

export function UpdateCurrentUserPylonUnreadBaselineRequestToJSON(json: any): UpdateCurrentUserPylonUnreadBaselineRequest {
    return UpdateCurrentUserPylonUnreadBaselineRequestToJSONTyped(json, false);
}

export function UpdateCurrentUserPylonUnreadBaselineRequestToJSONTyped(value?: UpdateCurrentUserPylonUnreadBaselineRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pylon_unread_baseline': value['pylon_unread_baseline'],
    };
}

